import { DigitalRevisionMenuItem } from '../interfaces/digital-revision-menu-item';
import { ProxyTypeEnum } from '../interfaces/proxy-type-enum';
import { MenuItemTypeEnum } from '../interfaces/menu-item-type-enum';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    ButtonURL: 'quick-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/PAR49/PAR49_QuickQuiz_v4',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>Test yourself with quizzes covering every topic. On your marks, get set... quiz!</p>\n' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every topic',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/PAR49/PAR49_YourMistakes_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>The quick quiz questions you got wrong are here — have another go and conquer them once and for all!</p>\n' +
      '\n' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Video-Explanations',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.RevisionSummary,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: 'revision-summary-test',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/PAR49/PAR49_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>See how well you understand each section. Mark your answers with our examples.</p>\n' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Questions marked <img src="assets/images/smiley-face-green.png" width="30" height="30" style="vertical-align:middle;" /> : <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Video-Explanations',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.VideoExplanations,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#FF9335',
    ButtonCustomClasses: '',
    ButtonText: 'Watch explanations',
    MixedOnlineTests: [],

    ButtonURL: 'video-explanations',
    HasData: false,
    HeadingText: 'Video Explanations',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Our Science experts break down key concepts for you — even the tricky bits!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Get to grips with key concepts',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Explanations',
        Intro:
          'These handy videos explain some of the key concepts in your book. So grab your popcorn (or a pencil) and dig in!',
        LeftSections: [
          {
            Header: 'Topic 1 — Energy',
            Subcategories: [
              {
                Name: 'Specific Heat Capacity',
                ShortName: 'Specific-Heat-Capacity',
                Link: 'https://www.youtube.com/embed/hJ8aplV4Aog?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2a — Circuits',
            Subcategories: [
              {
                Name: 'Sensing Circuits',
                ShortName: 'Sensing-Circuits',
                Link: 'https://www.youtube.com/embed/YgUJa8kw3C8?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2b — Everyday Electricity',
            Subcategories: [
              {
                Name: 'Static Electricity',
                ShortName: 'Static-Electricity',
                Link: 'https://www.youtube.com/embed/giwmpU42DCA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 3 — Particle Model of Matter',
            Subcategories: [
              {
                Name: 'States of Matter',
                ShortName: 'States-of-Matter',
                Link: 'https://www.youtube.com/embed/v4KmINy0IcA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 4 — Atomic Structure',
            Subcategories: [
              {
                Name: 'Half-life',
                ShortName: 'Half-life',
                Link: 'https://www.youtube.com/embed/LDFHzGwjK40?rel=0&modestbranding=1',
              },
              {
                Name: 'Fission and Fusion',
                ShortName: 'Fission-and-Fusion',
                Link: 'https://www.youtube.com/embed/AYUDB4d3YZY?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5a — Forces, Moments and Pressure',
            Subcategories: [
              {
                Name: 'Investigating Springs',
                ShortName: 'Investigating-Springs',
                Link: 'https://www.youtube.com/embed/FIVaAytimaM?rel=0&modestbranding=1',
              },
              {
                Name: 'Moments',
                ShortName: 'Moments',
                Link: 'https://www.youtube.com/embed/xTde7g4UUfU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5b — Forces and Motion',
            Subcategories: [
              {
                Name: 'Terminal Velocity',
                ShortName: 'Terminal-Velocity',
                Link: 'https://www.youtube.com/embed/LLOI0dG4zAg?rel=0&modestbranding=1',
              },
              {
                Name: "Newton\'s Third Law",
                ShortName: "Newton\'s Third Law",
                Link: 'https://www.youtube.com/embed/T_Bc3pHu8A4?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5c — Stopping Distances & Momentum',
            Subcategories: [
              {
                Name: 'Stopping Distances',
                ShortName: 'Stopping-Distances',
                Link: 'https://www.youtube.com/embed/pfKq48Wnwj8?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6a — Wave Basics and EM Waves',
            Subcategories: [
              {
                Name: 'Transverse and Longitudinal Waves',
                ShortName: 'Transverse-and-Longitudinal-Waves',
                Link: 'https://www.youtube.com/embed/bYIAZL-GcmE?rel=0&modestbranding=1',
              },
              {
                Name: 'Speed of Sound',
                ShortName: 'Speed-of-Sound',
                Link: 'https://www.youtube.com/embed/G8wx_4G18iM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6b — Light and Radiation',
            Subcategories: [
              {
                Name: 'Convex Lenses',
                ShortName: 'Convex-Lenses',
                Link: 'https://www.youtube.com/embed/HqoaGJ0v-HQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 7 — Magnetism and Electromagnetism',
            Subcategories: [
              {
                Name: 'Electromagnets',
                ShortName: 'Electromagnets',
                Link: 'https://www.youtube.com/embed/jjmRhWiMLPA?rel=0&modestbranding=1',
              },
              {
                Name: 'Motor Effect',
                ShortName: 'Motor-Effect',
                Link: 'https://www.youtube.com/embed/viyulXAMksk?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 8 — Space Physics',
            Subcategories: [
              {
                Name: 'Life Cycle of Stars',
                ShortName: 'Life-Cycle-of-Stars',
                Link: 'https://www.youtube.com/embed/bPullKoQ45A?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.VideoSolutions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    MixedOnlineTests: [],

    ButtonURL: 'content-videos',
    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Learn how to answer the exam-style questions in your book</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Topic 1 — Energy Stores & Transfers',
            Subcategories: [
              {
                Name: 'Energy Stores and Transfers',
                ShortName: 'Energy-Stores-and-Transfers',
                Link: 'https://www.youtube.com/embed/fGtie6c3dEA?rel=0&modestbranding=1',
              },
              {
                Name: 'Kinetic and Potential Energy Stores',
                ShortName: 'Kinetic-and-Potential-Energy-Stores',
                Link: 'https://www.youtube.com/embed/QzKGF5Recv4?rel=0&modestbranding=1',
              },
              {
                Name: 'Specific Heat Capacity',
                ShortName: 'Specific-Heat-Capacity',
                Link: 'https://www.youtube.com/embed/-7Ld5j5l84k?rel=0&modestbranding=1',
              },
              {
                Name: 'Power Output',
                ShortName: 'Power-Output',
                Link: 'https://www.youtube.com/embed/jHR0vsRlNmM?rel=0&modestbranding=1',
              },
              {
                Name: 'Efficiency',
                ShortName: 'Efficiency',
                Link: 'https://www.youtube.com/embed/BORdE6I2aTM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2a — Circuits',
            Subcategories: [
              {
                Name: 'Current and Charge',
                ShortName: 'Current-and-Charge',
                Link: 'https://www.youtube.com/embed/odLKOSpmkXE?rel=0&modestbranding=1',
              },
              {
                Name: 'Resistance',
                ShortName: 'Resistance',
                Link: 'https://www.youtube.com/embed/7e6rBWc98a0?rel=0&modestbranding=1',
              },
              {
                Name: 'I-V Characteristics',
                ShortName: 'I-V-Characteristics',
                Link: 'https://www.youtube.com/embed/hwO_Tdi1dV8?rel=0&modestbranding=1',
              },
              {
                Name: 'Series Circuits',
                ShortName: 'Series-Circuits',
                Link: 'https://www.youtube.com/embed/6fF3TpR_fVU?rel=0&modestbranding=1',
              },
              {
                Name: 'Parallel Circuits',
                ShortName: 'Parallel-Circuits',
                Link: 'https://www.youtube.com/embed/8QsEyZ9dTwE?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2b — Everyday Electricity',
            Subcategories: [
              {
                Name: 'Energy Transfers and Power',
                ShortName: 'Energy-Transfers-and-Power',
                Link: 'https://www.youtube.com/embed/bAiQYooP6XI?rel=0&modestbranding=1',
              },
              {
                Name: 'Power and Resistance',
                ShortName: 'Power-and-Resistance',
                Link: 'https://www.youtube.com/embed/xe4J0NHlFdE?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 3 — Particle Model of Matter',
            Subcategories: [
              {
                Name: 'Investigating Density',
                ShortName: 'Investigating-Density',
                Link: 'https://www.youtube.com/embed/L9E_e8Q814g?rel=0&modestbranding=1',
              },
              {
                Name: 'Specific Latent Heat',
                ShortName: 'Specific-Latent-Heat',
                Link: 'https://www.youtube.com/embed/lJv-pvoThPk?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 4 — Atomic Structure',
            Subcategories: [
              {
                Name: 'Uses of Nuclear Radiation',
                ShortName: 'Uses-of-Nuclear-Radiation',
                Link: 'https://www.youtube.com/embed/OhIWz7KDkZw?rel=0&modestbranding=1',
              },
              {
                Name: 'Nuclear Equations',
                ShortName: 'Nuclear-Equations',
                Link: 'https://www.youtube.com/embed/1WltKjOBMhM?rel=0&modestbranding=1',
              },
              {
                Name: 'Half-life',
                ShortName: 'Half-life',
                Link: 'https://www.youtube.com/embed/YqM9QAx_oHk?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic 5a — Forces, Moments and Pressure',
            Subcategories: [
              {
                Name: 'Weight',
                ShortName: 'Weight',
                Link: 'https://www.youtube.com/embed/bHxvKmKYjxI?rel=0&modestbranding=1',
              },
              {
                Name: 'Work Done',
                ShortName: 'Work-Done',
                Link: 'https://www.youtube.com/embed/4tkvOfqiB0k?rel=0&modestbranding=1',
              },
              {
                Name: 'Spring Constant',
                ShortName: 'Spring-Constant',
                Link: 'https://www.youtube.com/embed/TdjRewv7nKg?rel=0&modestbranding=1',
              },
              {
                Name: 'Balanced Moments',
                ShortName: 'Balanced-Moments',
                Link: 'https://www.youtube.com/embed/z4CK6rJliIg?rel=0&modestbranding=1',
              },
              {
                Name: 'Fluid Pressure',
                ShortName: 'Fluid-Pressure',
                Link: 'https://www.youtube.com/embed/lqRgyxc6924?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5b — Forces and Motion',
            Subcategories: [
              {
                Name: 'Speed',
                ShortName: 'Speed',
                Link: 'https://www.youtube.com/embed/w3jlwjfPcPw?rel=0&modestbranding=1',
              },
              {
                Name: 'Acceleration',
                ShortName: 'Acceleration',
                Link: 'https://www.youtube.com/embed/YBx3NEUn3Uc?rel=0&modestbranding=1',
              },
              {
                Name: 'Velocity-Time Graphs',
                ShortName: 'Velocity-Time-Graphs',
                Link: 'https://www.youtube.com/embed/ueeGyuDbap4?rel=0&modestbranding=1',
              },
              {
                Name: "Newton\'s Third Law",
                ShortName: "Newton\'s Third Law",
                Link: 'https://www.youtube.com/embed/LBi-TZJjPXk?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5c — Stopping Distances & Momentum',
            Subcategories: [
              {
                Name: 'Stopping Distances',
                ShortName: 'Stopping-Distances',
                Link: 'https://www.youtube.com/embed/3DmjCP-JDoU?rel=0&modestbranding=1',
              },
              {
                Name: 'Reaction Times',
                ShortName: 'Reaction-Times',
                Link: 'https://www.youtube.com/embed/HPIm7hP8Mbc?rel=0&modestbranding=1',
              },
              {
                Name: 'Momentum',
                ShortName: 'Momentum',
                Link: 'https://www.youtube.com/embed/F2NWVgIvJlM?rel=0&modestbranding=1',
              },
              {
                Name: 'Conservation of Momentum',
                ShortName: 'Conservation-of-Momentum',
                Link: 'https://www.youtube.com/embed/jtvjXvsPGEU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6a — Wave Basics and EM Waves',
            Subcategories: [
              {
                Name: 'Wave Speed',
                ShortName: 'Wave-Speed',
                Link: 'https://www.youtube.com/embed/HEVIHl13H6s?rel=0&modestbranding=1',
              },
              {
                Name: 'Refraction',
                ShortName: 'Refraction',
                Link: 'https://www.youtube.com/embed/eF-vqbHAzEU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6b — Light, Radiation & Other Waves',
            Subcategories: [
              {
                Name: 'Convex Lenses',
                ShortName: 'Convex-Lenses',
                Link: 'https://www.youtube.com/embed/ZI0Rm63UPP0?rel=0&modestbranding=1',
              },
              {
                Name: 'Magnification',
                ShortName: 'Magnification',
                Link: 'https://www.youtube.com/embed/-Bfpv-Y-qE4?rel=0&modestbranding=1',
              },
              {
                Name: 'Black Body Radiation',
                ShortName: 'Black-Body-Radiation',
                Link: 'https://www.youtube.com/embed/iFsWGnM-SQU?rel=0&modestbranding=1',
              },
              {
                Name: 'Ultrasound',
                ShortName: 'Ultrasound',
                Link: 'https://www.youtube.com/embed/PfkjFnG6Hs0?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 7 — Magnetism and Electromagnetism',
            Subcategories: [
              {
                Name: "Fleming\'s Left-Hand Rule",
                ShortName: "Fleming\'s Left-Hand Rule",
                Link: 'https://www.youtube.com/embed/GGCCAEXE-dM?rel=0&modestbranding=1',
              },
              {
                Name: 'Transformers',
                ShortName: 'Transformers',
                Link: 'https://www.youtube.com/embed/f5T_Pfck8J0?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 8 — Space Physics',
            Subcategories: [
              {
                Name: 'Orbits',
                ShortName: 'Orbits',
                Link: 'https://www.youtube.com/embed/4Uapf5ZooxE?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'quick-quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'revision-summary-test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'content-videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.HowToRevise,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#0993A3',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: 'how-to-revise',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'How to Revise',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "We\'ve spilled all the secrets to help you get the most out of your book and CGP RevisionHub",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Revision tips and tricks',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        LeftSections: [],
        RightSections: [],
        Title: '',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      IntroTitle: '',
      AdditionalInfo: '',
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: 'GCSE Physics',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#E04693',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Products',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>Printable answers, resource sheets, exam tips and a glossary... yep, it\'s all right here.</p>\n",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<p>Your printable answers, resource sheets, exam tips and more are all below. Take your pick!</p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/PAR49/PDFs/cgp-gcse-physics-commandwords.pdf" target="_blank">Command Word Glossary</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/PAR49/PDFs/cgp-gcse-physics-examrules.pdf" target="_blank">Golden Rules for Your Exam</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/PAR49/PDFs/cgp-gcse-physics-formulas-higher.pdf" target="_blank">Physics Formulas</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/PAR49/PDFs/cgp-gcse-physics-summaryanswers-higher.pdf" target="_blank">Revision Summary Test Answers</a></p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Watch our useful video to get started or take a look at the FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        'We’ve put together lots of helpful information on how to get the most out of your Revision Guide. And if you’ve hit any snags, you’ll find the answers you need here too. ',
      Text:
        '    <h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5>What is CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Science books. Use the quizzes, tests, videos and more to revise what you’ve learned from your book and practise for the exams.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I access CGP RevisionHub?</h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Just give them a scan and you'll automatically be taken to the relevant quiz, video or other revision thingy-ma-jig so you can practise exactly what you've just learned!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>My RevisionHub isn’t working — what do I do?&nbsp;</h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact" style="color: #1494D4;">Customer Services team</a>.&nbsp;&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Do I need an internet connection to use CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — there are also lots of useful bits that you can download as PDFs to access offline. Phew.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>If I log in on a different device, will all my progress be saved?&nbsp;</h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What’s the difference between the Quick Quizzes, Your Mistakes Quiz and Revision Summary Tests?</h5>\n' +
        '\n' +
        "<p>Quick Quizzes are...well, quick! They're a speedy way to test yourself on all the key facts, maths skills and practical skills on the course. There's one on almost every page of your book — we're generous like that.</p>\n" +
        '\n' +
        "<p>Your Mistakes Quiz tests you on any questions you got wrong in your Quick Quizzes. It's really helpful for targeting those bits you find trickier.</p>\n" +
        '\n' +
        "<p>Revision Summary Tests include more challenging questions — if you can do them all, you'll know you've covered everything. You'll find one at the end of every section in your book and you can mark them yourself using our example answers.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I clear my progress so far in the Hub and start again?&nbsp;</h5>\n' +
        '\n' +
        "<p>There are no takie-backsies in CGP RevisionHub, so you can't clear your results and start again. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores. Plus, you can edit your Revision Summary Test answers as your skills and understanding develop. Keep going, we believe in you!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I share my quiz scores and test results with other people?&nbsp;</h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What happens when I’ve answered all the questions?&nbsp;</h5>\n' +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams. Check out the How To Revise page in your RevisionHub if you want more top revision tips before your exams.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Will I always have access to CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise.<br>\n" +
        '&nbsp;</p>',
      VideoLink: 'https://www.youtube.com/embed/sURtVqRez6Q?rel=0&modestbranding=1',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Video Explanations',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'Content-Videos',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      'There’s plenty more revision where this came from! Take a look at some of our other revision books.',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
];
